export interface FrequencyFormModel {
    id?: number;
    description?: string;
    frequency?: number,
    frequency_unit?: string,
    frequency_time?: string,
    time_zone?: string,
    specific_date?: Date,
    is_specific_date_recurrent?: string,
    message: string
    is_specific_date: string,
    specific_time?: string
}


export const newFrequencyInitialValues: FrequencyFormModel = {
    frequency: 1,
    frequency_unit: 'month',
    frequency_time: '09:00',
    message: '',
    is_specific_date: '0',
    is_specific_date_recurrent: '0'
};

export interface ClientLeadFrequencyAutomation {
    id: number;
    followup_message_id?: number;
    followup_message?: FrequencyFormModel;
    lead_id?: number;
    client_id?: number;
    next_execution?: Date;
    deleted_at?: Date;
}